import React from "react";
import Header from "../components/Common/Header";
import MainComponent from "../components/LandingPage/MainComponent";

function Home() {
  return (
    <>
      <Header />
      <MainComponent />
    </>
  );
}

export default Home;
